import { NivelAlgoritmoEnum, TipoAlgoritmoEnum } from "../../../../../enums";

type Props = {
  nivel: number;
  tipoAlgoritmo: number;
};

export function GerarVariaveis({ nivel, tipoAlgoritmo }: Props) {
  let lista: number[] = [];
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      lista.push(Math.floor(Math.random() * 35));
      lista.push(Math.floor(Math.random() * 57));
      TipoAlgoritmoEnum.REPETICOES === tipoAlgoritmo
        ? lista.push(Math.floor(Math.random() * 100))
        : lista.push(Math.floor(Math.random() * 73));
      return lista;

    case NivelAlgoritmoEnum.MEDIO:
      if (TipoAlgoritmoEnum.REPETICOES === tipoAlgoritmo) {
        lista.push(Math.floor(Math.random() * 35));
        lista.push(Math.floor(Math.random() * 57));
        lista.push(Math.floor(Math.random() * 73));
        lista.push(Math.floor(Math.random() * 777));
      } else {
        lista.push(Math.floor(Math.random() * 35));
        lista.push(Math.floor(Math.random() * -57));
        lista.push(Math.floor(Math.random() * 73));
        lista.push(Math.floor(Math.random() * -13));
      }
      return lista;
    default:
      if (TipoAlgoritmoEnum.REPETICOES === tipoAlgoritmo) {
        lista.push(Math.floor(Math.random() * 35));
        lista.push(Math.floor(Math.random() * 57));
        lista.push(Math.floor(Math.random() * 73));
        lista.push(Math.floor(Math.random() * 9999));
      } else {
        lista.push(Math.floor(Math.random() * -35));
        lista.push(Math.floor(Math.random() * -57));
        lista.push(Math.floor(Math.random() * 73));
        lista.push(Math.floor(Math.random() * -33));
        lista.push(Math.floor(Math.random() * 77));
      }
      return lista;
  }
}
